export default __webpack_public_path__ + "static/media/photo--sm--group.826ea8c7.jpg";